import type React from 'react';

import s from './styles.module.scss';

export enum BadgeVariants {
  default = 'default',
  blue = 'blue',
  green = 'green',
  outline = 'outline',
}

interface BadgeProps {
  variant?: BadgeVariants;
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ variant = BadgeVariants.default, children, className = '' }) => {
  const variantStyles: Record<BadgeVariants, string> = {
    [BadgeVariants.default]: s.default,
    [BadgeVariants.blue]: s.blue,
    [BadgeVariants.green]: s.green,
    [BadgeVariants.outline]: s.outline,
  };

  const combinedClassName = `${s.badge} ${variantStyles[variant]} ${className}`;

  return <span className={combinedClassName}>{children}</span>;
};
